import emptySliceApi from '../../../../../shared/store/emptyApiSlice';
import { AdministratorUserApiModel } from '../models';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdministratorUsers: builder.query<AdministratorUserApiModel[], string>({
      query: (accountId) => `v4/accounts/${accountId}/admins`,
      providesTags: ['Admin'],
    }),
    resentAdminInvitation: builder.mutation<
      any,
      { accountId: string; inviteId: string }
    >({
      query: ({ accountId, inviteId }) => ({
        url: `v4/accounts/${accountId}/invites/${inviteId}/resend`,
        method: 'POST',
      }),
      invalidatesTags: ['Admin'],
    }),
  }),
});

export const {
  useGetAdministratorUsersQuery,
  useResentAdminInvitationMutation,
} = apiSlice;
